<template>
  <a :href="event_href" target="_blank">
    <b-card :title="event.name" :sub-title="start_time_formatted" class="mb-2">
      <b-card-body>
        <b-row>
          <b-col>
            <p>{{event.description}}</p>
          </b-col>
        </b-row>
      </b-card-body>
      <b-row>
        <b-col>
          <iframe
            width="100%"
            height="100"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            allowfullscreen
            :src="google_map_src"
          />
        </b-col>
      </b-row>
      <template v-slot:footer>
        <b-row>
          <b-col>
            <div>{{event.place.name}}</div>
            <div>{{event.place.location.street}}</div>
            <div>{{event.place.location.city}}, {{event.place.location.state}} {{event.place.location.city.zip}}</div>
          </b-col>
        </b-row>
      </template>
    </b-card>
  </a>
</template>

<script lang="ts">
import GoogleApiService from "../services/GoogleApiService";

export default {
  props: {
    event: Object
  },
  computed: {
    start_time_formatted() {
      return this.event.start_time.format("MMMM Do, YYYY");
    },
    event_href() {
      return `https://www.facebook.com/events/${this.event.id}`;
    },
    google_map_src() {
      return `https://www.google.com/maps/embed/v1/place?key=${GoogleApiService.GetToken()}&q=location:${
        this.event.place.location.latitude
      },${this.event.place.location.longitude}`;
    }
  }
};
</script>

<style lang="scss" scoped>
a,
a:hover {
  text-decoration: inherit;
  color: inherit;
  white-space: pre-line;
}
</style>